import moment from 'moment';
import 'moment/locale/de'; // Import German locale

const FormatDateTime = ({ dateTime }) => {
  moment.locale('de');

  // Parse the datetime string using moment
  const date = moment(dateTime);

  // Format the date in the desired format
  return date.format('DD.MM.YYYY - HH:mm');
};

export default FormatDateTime;
